import type React from 'react';
import type { BadgeTone } from '../../../ui';

/** Constants and formatters shared by the Backlinks tabs and panels. */

export const faint: React.CSSProperties = { color: 'var(--text-faint)' };

export const textareaStyle: React.CSSProperties = {
  width: '100%',
  resize: 'vertical',
  minHeight: '96px',
  padding: '10px 12px',
  borderRadius: 'var(--radius-sm)',
  border: '1px solid var(--border-hairline)',
  background: 'var(--surface-input)',
  color: 'var(--text-body)',
  font: 'inherit',
  fontSize: 'var(--text-sm)',
};

export const linkStyle: React.CSSProperties = { color: 'var(--accent-text)', textDecoration: 'none' };

export const TYPE_LABELS: Record<string, string> = {
  competitor_gap: 'Competitor gap',
  directory: 'Directory',
  unlinked_mention: 'Unlinked mention',
  broken_link: 'Broken link',
  resource_page: 'Resource page',
  guest_post: 'Guest post',
  manual: 'Manual',
};

export const STATUS: Record<string, { label: string; tone: BadgeTone }> = {
  new: { label: 'New', tone: 'accent' },
  approved: { label: 'Approved', tone: 'info' },
  outreach_drafted: { label: 'Drafted', tone: 'warn' },
  pitched: { label: 'Pitched', tone: 'warn' },
  won: { label: 'Won', tone: 'up' },
  declined: { label: 'Declined', tone: 'idle' },
  ignored: { label: 'Ignored', tone: 'idle' },
};

export function formatRelative(iso: string): string {
  const days = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
  if (days <= 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 7) return `${days}d ago`;
  if (days < 30) return `${Math.floor(days / 7)}w ago`;
  if (days < 365) return `${Math.floor(days / 30)}mo ago`;
  return `${Math.floor(days / 365)}y ago`;
}

export function fmtDate(iso: string | null): string {
  return iso ? new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—';
}

export function urlPath(url: string): string {
  try {
    const u = new URL(url);
    return u.pathname + u.search || '/';
  } catch {
    return url;
  }
}

export function fmtCompact(n: number | null): string {
  if (n == null) return '—';
  return n >= 10000 ? `${Math.round(n / 1000)}k` : n.toLocaleString();
}
